// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item[data-v-194e03cc] {
  display: flex;
  cursor: pointer;
  padding-left: 10px;
}
.item[data-v-194e03cc]:hover {
  background-color: var(--list-item-bghover);
}
.item .photo[data-v-194e03cc] {
  display: flex;
  align-items: center;
  margin-left: 4px;
}
.item-list[data-v-194e03cc] {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 6px;
  padding-right: 2px;
  height: 72px;
  width: 100%;
  max-width: calc(100% - 58px);
}
.item-title[data-v-194e03cc] {
  display: flex;
  justify-content: space-between;
  line-height: 1.2em;
  font-size: 16px;
}
.item-title .title-left[data-v-194e03cc] {
  position: relative;
  max-width: 196px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-title .title-left .title-channel[data-v-194e03cc],
.item-title .title-left .title-pub[data-v-194e03cc] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-title .title-right[data-v-194e03cc] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: end;
  min-width: 77px;
  font-size: 12px;
  color: var(--toolbtn-color);
}
.item-subtitle[data-v-194e03cc] {
  font-size: 12px;
  display: -webkit-box;
  line-height: 1.25em;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.item-subtitle .subtitle-media[data-v-194e03cc] {
  display: flex;
  align-items: center;
}
.item-subtitle .subtitle-media .subtitle-file-icon[data-v-194e03cc] {
  display: flex;
  align-items: center;
}
.item-subtitle .subtitle-media .subtitle-file-icon i[data-v-194e03cc] {
  font-size: 1.4em;
  margin-right: 0.3em;
}
.item-subtitle .subtitle-media .subtitle-file-icon .media-video[data-v-194e03cc] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  min-width: 16px;
  height: 16px;
  background-color: #76a7f3;
  border-radius: 50%;
  margin: auto;
}
.item-subtitle .subtitle-media .subtitle-file-icon .media-video i[data-v-194e03cc] {
  position: relative;
  font-size: 1em;
  margin-right: -0.15em;
  margin-bottom: -0.05em;
}
.item-subtitle .subtitle-file-name[data-v-194e03cc] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-subtitle .subtitle-text[data-v-194e03cc] {
  line-height: 1.35em;
}
.item-subtitle .subtitle-text[data-v-194e03cc] > .subtitle-fio {
  color: var(--toolbtn-color);
  line-height: 1.2em;
}
.item-subtitle .subtitle-text[data-v-194e03cc] .highlighted {
  background-color: var(--highlighted-bgcolor);
  color: var(--bg-color);
  font-weight: 600;
}
.item .pub[data-v-194e03cc] {
  -webkit-line-clamp: 1;
  line-clamp: 1;
}
.item .subtitle-comment-message[data-v-194e03cc] {
  line-height: 1.5em;
  max-width: 100%;
  color: #acbed7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/listItems/GlobalSearchListItem.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".item[data-v-194e03cc] {\n  display: flex;\n  cursor: pointer;\n  padding-left: 10px;\n}\n.item[data-v-194e03cc]:hover {\n  background-color: var(--list-item-bghover);\n}\n.item .photo[data-v-194e03cc] {\n  display: flex;\n  align-items: center;\n  margin-left: 4px;\n}\n.item-list[data-v-194e03cc] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-left: 6px;\n  padding-right: 2px;\n  height: 72px;\n  width: 100%;\n  max-width: calc(100% - 58px);\n}\n.item-title[data-v-194e03cc] {\n  display: flex;\n  justify-content: space-between;\n  line-height: 1.2em;\n  font-size: 16px;\n}\n.item-title .title-left[data-v-194e03cc] {\n  position: relative;\n  max-width: 196px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.item-title .title-left .title-channel[data-v-194e03cc],\n.item-title .title-left .title-pub[data-v-194e03cc] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.item-title .title-right[data-v-194e03cc] {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  min-width: 77px;\n  font-size: 12px;\n  color: var(--toolbtn-color);\n}\n.item-subtitle[data-v-194e03cc] {\n  font-size: 12px;\n  display: -webkit-box;\n  line-height: 1.25em;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.item-subtitle .subtitle-media[data-v-194e03cc] {\n  display: flex;\n  align-items: center;\n}\n.item-subtitle .subtitle-media .subtitle-file-icon[data-v-194e03cc] {\n  display: flex;\n  align-items: center;\n}\n.item-subtitle .subtitle-media .subtitle-file-icon i[data-v-194e03cc] {\n  font-size: 1.4em;\n  margin-right: 0.3em;\n}\n.item-subtitle .subtitle-media .subtitle-file-icon .media-video[data-v-194e03cc] {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  min-width: 16px;\n  height: 16px;\n  background-color: #76a7f3;\n  border-radius: 50%;\n  margin: auto;\n}\n.item-subtitle .subtitle-media .subtitle-file-icon .media-video i[data-v-194e03cc] {\n  position: relative;\n  font-size: 1em;\n  margin-right: -0.15em;\n  margin-bottom: -0.05em;\n}\n.item-subtitle .subtitle-file-name[data-v-194e03cc] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.item-subtitle .subtitle-text[data-v-194e03cc] {\n  line-height: 1.35em;\n}\n.item-subtitle .subtitle-text[data-v-194e03cc] > .subtitle-fio {\n  color: var(--toolbtn-color);\n  line-height: 1.2em;\n}\n.item-subtitle .subtitle-text[data-v-194e03cc] .highlighted {\n  background-color: var(--highlighted-bgcolor);\n  color: var(--bg-color);\n  font-weight: 600;\n}\n.item .pub[data-v-194e03cc] {\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n.item .subtitle-comment-message[data-v-194e03cc] {\n  line-height: 1.5em;\n  max-width: 100%;\n  color: #acbed7;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
